export default __webpack_public_path__ + "static/ProValue_3@992-8e71951f8800fa087c595fe85008a225.webp";